<template>
    <div class="d-flex preparation-datepicker">
        <div v-if="errors" class="flex-fill">
            <ErrorsZone :errors="errors" />
        </div>
        <div v-if="!errors" class="flex-fill position-relative">
            <bootstrap-datepicker
                ref="datepicker"
                class="delivery-datepicker mb-2"
                v-model="endPreparationDate"
                :day-cell-content="getDayCellContent"
                @selected="onSelectDate" />
            <div v-if="loading" class="px-2 pt-2 loader right">
                <i class="fas fa-circle-notch fa-spin"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import {useGetLoader} from '../../compositions/axios/loadingRequest';
    import {momentDay, momentDaysAreSame} from "../../../moment-with-helpers";

    import BootstrapDatepicker from '../../BootstrapDatepicker';
    import ErrorsZone from "../../ErrorsZone";

    export default {
        name: 'PreparationDatepicker',

        components: {
            'bootstrap-datepicker': BootstrapDatepicker,
            'errors-zone': ErrorsZone,
        },

        props: {
            value: {
                type: String,
                required: false,
            }
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data: function () {
            return {
                endPreparationDate: this.value,
                calendar: null,
                loadedOnce: false,
            };
        },

        created() {
            Echo.private(`employees`)
                .listen('OrderUpdatedEvent', (e) => {
                    this.loadDates();
                });
        },

        async mounted() {
            this.loadDates();
        },

        methods: {
            getDayCellContent(params) {
                let cellClass = '';
                if(this.calendar) {
                    let date = new Date(params.timestamp);
                    let dateFormatted = momentDay(date).format('YYYY-MM-DD');
                    let dateInfos = this.calendar[dateFormatted];
                    if(dateInfos) {
                        cellClass += 'font-weight-bold ';
                        if(dateInfos.status && dateInfos.status.color) {
                            cellClass += 'preparation-color-'+dateInfos.status.color+' ';
                        } else {
                            cellClass += 'preparation-color-cyan ';
                        }
                    }
                }
                return `<span class="${cellClass}">${params.date}</span>`;
            },

            async loadDates() {
                const data = await this.load(`/espace-employes/commandes/preparation/calendrier-dates-preparation`);
                if (data) {
                    this.calendar = data.calendar;
                }
                this.loadedOnce = true;
            },

            onSelectDate(e) {
                if (e instanceof Date) {
                    var date = moment(e).format('YYYY-MM-DD')
                    window.location = '/espace-employes/commandes/preparation/' + date;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .preparation-datepicker {
        .loader {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
</style>

<style lang="scss">
    .preparation-datepicker {
        .cell.today {
            background: #dedede !important;
        }
        .cell.selected {
            border: 1px solid #888 !important;
        }
    }
</style>
